import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UtilitiesService } from '../services/utilities/utilities.service';
import * as moment from 'vendors/moment-locale-th';

@Pipe({
  name: 'actDate',
  pure: false
})
export class ActDatePipe implements PipeTransform {

  constructor(
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
  ) {}

  transform(value: string, inputFormat?: string): any {
    const lang = this.appConfigService.getLanguage();
    const invalidValue = [undefined, null].indexOf(value) > -1;
    if (inputFormat && !invalidValue) {
      value = moment(value, inputFormat).format('YYYY-MM-DD');
    }
    const dateResult =  !invalidValue ? this.utilitiesService.getOtaFormatYear(lang, value) : 'DD MM YYYY';
    // console.log(`value:${value} result:${dateResult}`);
    return dateResult;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/act-date.pipe.ts